import LoginForm from "../../components/loginform/LoginForm";

const Login = () => {
  return <LoginForm />;
};

export default Login;
